import React from 'react';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { TranslationPullCommand } from '../components/TranslationPullCommand/index.js';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import { executeCommand } from './execute-command.js';

export async function nonInteractiveTranslationPull(
  services: AstroCommandServices,
  model: ProjectModel
) {
  await executeCommand<void>(services, model, (resolve) => (
    <TranslationPullCommand onComplete={resolve} />
  ));

  log(JSON.stringify({ success: true }, null, 2));
}
